module.exports = __webpack_public_path__ + "static/img/3.f5d03ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/3.png
// module id = waeG
// module chunks = 0